'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [11088,61446];
var unicode = 'f005';
var svgPathData = 'M359.6 157.6l-7.4-14.5-64.1-125.5-64.1 125.5-7.4 14.5-16.1 2.6-139.2 22.1 99.6 99.7 11.5 11.5-2.5 16.1-22 139.2 125.6-63.9 14.5-7.4 14.5 7.4 125.6 63.9-22-139.2-2.5-16.1 11.5-11.5 99.6-99.7-139.2-22.1-16.1-2.6zm183.2-3.3l39 6.2c-3.9 3.9-51.9 52-143.9 144.1 20.3 128.6 30.9 195.6 31.7 201.2-5-2.5-65.5-33.3-181.5-92.3-116 59-176.5 89.8-181.5 92.3 .9-5.5 11.4-72.6 31.7-201.2-92-92.1-140-140.1-143.9-144.1 5.5-.9 72.6-11.5 201.1-32 59.2-116 90-176.4 92.6-181.4 2.5 5 33.4 65.4 92.6 181.4l162.1 25.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;